import cx from 'clsx';
import * as React from 'react';
import styles from './included-in-all-plans.module.css';

interface IncludedInAllPlansProps {
  title: string;
  benefits: string[];
}

export function IncludedInAllPlans({ title, benefits }: IncludedInAllPlansProps): React.ReactNode {
  return (
    <div className={styles.container}>
      <h3 className={cx('heading-subsection', styles.title)}>{title}</h3>
      <ul className={styles.list}>
        {benefits.map(description => (
          <li className={cx(styles['list-item'], 'body-standard')} key={description}>
            <span>{description}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
